var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-portlet__body" },
    [
      _c("s-datatable", {
        attrs: { config: _vm.datatable },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function(props) {
              return _c("div", {}, [
                _vm.validPermission("modify", "permission")
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit",
                        attrs: {
                          "data-toggle": "modal",
                          "data-backdrop": "static",
                          "data-keyboard": "false",
                          "data-target": "#permission_modal",
                          title: _vm._f("capitalize")("edit_permission")
                        },
                        on: {
                          click: function($event) {
                            return _vm.goToEditPermission(props.row)
                          }
                        }
                      },
                      [_c("i", { staticClass: "la la-edit" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.validPermission("change", "permission")
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_delete",
                        attrs: { title: _vm._f("capitalize")("update_status") },
                        on: {
                          click: function($event) {
                            return _vm.changeStatusPermission(props.row.id)
                          }
                        }
                      },
                      [_c("i", { staticClass: "la la-leaf" })]
                    )
                  : _vm._e()
              ])
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-125f7a9e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-125f7a9e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/permissions/All.vue
// module id = 722
// module chunks = 0 1 82